import { Box, type SxProps } from '@mui/material';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@/components/accordion';

interface MultiAccordionsItemProps {
  testid?: string;
  isMulti?: boolean;
  isSelected?: boolean;
  onSelect?: () => void;
  defaultExpanded?: boolean;
  summary: React.ReactNode;
  Details: React.ReactNode;
  sx?: SxProps;
}

export const MultiAccordionsItem = (props: MultiAccordionsItemProps) => {
  const {
    testid,
    isSelected,
    isMulti,
    onSelect,
    summary,
    Details,
    defaultExpanded,
    sx,
  } = props;
  return isMulti ? (
    <Accordion
      data-testid={testid}
      sx={{
        paddingY: '12px',
        paddingLeft: '40px',
        ...sx,
      }}
      expanded={isSelected}
      defaultExpanded={defaultExpanded}
    >
      <AccordionSummary
        sx={{
          '& .MuiTypography-root': { fontWeight: '400 !important' },
        }}
        onClick={onSelect}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails>{Details}</AccordionDetails>
    </Accordion>
  ) : (
    <Box padding='24px 40px'>
      {summary && <Box paddingBottom='24px'>{summary}</Box>}
      {Details}
    </Box>
  );
};
